import { useState } from 'react';
import useAuth from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import useAlertHandler from '../hooks/useAlertHandler';
import Alert, { ALERT_TYPE } from '../components/form-components/Alerts';

const Registerpage = () => {
  const [userName, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [secretCode, setSecretCode] = useState('');

  const { register } = useAuth();
  const navigate = useNavigate();

  const { alertType, alertHeader, alertDescription, resetAlert, displayAlert } =
    useAlertHandler();

  const onRegister = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      displayAlert(
        ALERT_TYPE.ERROR.type,
        'Invalid Password Confirmation Mismatch',
        'The password and confirm password fields must be identical. Please verify your inputs'
      );
      return;
    }
    // check if password and confirmed password matched
    const registerDto = {
      username: userName,
      email: email,
      password: password,
      secret_code: secretCode,
    };

    try {
      await register(registerDto);
      resetAlert();
      navigate('/login');
    } catch (err) {
      displayAlert(ALERT_TYPE.ERROR.type, 'Registration Failed', err.message);
    }
  };

  return (
    <>
      <div className="flex min-h-full items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
        <div className="w-full max-w-md space-y-8">
          <div>
            {!!alertType && (
              <Alert
                alertType={alertType}
                alertHeader={alertHeader}
                alertDescription={alertDescription}
              ></Alert>
            )}
          </div>
          <div>
            <img
              className="mx-auto h-16 w-auto"
              src="/logo_lg.png"
              alt="Time To Makan"
            />
            <h2 className="mt-6 text-center text-xl font-bold tracking-tight text-gray-900">
              Register for a new account
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600">
              Or Login to your account{' '}
              <a
                href="/login"
                className="font-medium text-indigo-600 hover:text-indigo-500"
              >
                here
              </a>
            </p>
          </div>
          <form className="mt-8 space-y-6" onSubmit={onRegister}>
            <div className="-space-y-px rounded-md shadow-sm space-y-4">
              <div>
                <input
                  id="username"
                  name="username"
                  type="text"
                  autoComplete="username"
                  required
                  className="relative block w-full rounded-t-md border-0 px-2 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  placeholder="Username"
                  onChange={(e) => {
                    setUsername(e.target.value);
                  }}
                />
              </div>
              <div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  className="relative block w-full rounded-t-md border-0 px-2 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  placeholder="Email Address"
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
              </div>
              <div>
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  className="relative block w-full rounded-b-md border-0 px-2 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  placeholder="Password"
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                />
              </div>
              <div>
                <input
                  id="confirmPassword"
                  name="confirmPassword"
                  type="password"
                  autoComplete="current-confirmPassword"
                  required
                  className="relative block w-full rounded-b-md border-0 px-2 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  placeholder="Confirm Password"
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                  }}
                />
              </div>
            </div>
            <div>
              <input
                id="secretCode"
                name="secretCode"
                type="text"
                autoComplete="current-confirmPassword"
                required
                className="relative block w-full rounded-b-md border-0 px-2 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                placeholder="Secret Code"
                onChange={(e) => {
                  setSecretCode(e.target.value);
                }}
              />
            </div>
            <div>
              <button
                type="submit"
                className="group relative flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Register
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Registerpage;
